export const updateRelayedConnector = (id, partialUpdatedConnection, relayedConnectorsRef) => {
    const relayedConnector = relayedConnectorsRef.current[id];
    if (!relayedConnector) {
        return;
    }
    relayedConnector.redraw(Object.assign(Object.assign({}, relayedConnector.props), partialUpdatedConnection));
};
export const updateRelayedNode = (id, partialUpdatedNode, relayedNodesRef) => {
    const relayedNode = relayedNodesRef.current[id];
    if (!relayedNode) {
        return;
    }
    relayedNode.redraw(Object.assign(Object.assign({}, relayedNode.props), { node: Object.assign(Object.assign({}, relayedNode.props.node), partialUpdatedNode) }));
};
